import { createAsyncThunk } from '@reduxjs/toolkit';
import { wsMmSend } from '@skynet/data-ws-mm';
import type { CreateApiKeyPayload, CreateSubAccountPayload, UpdateApiKeyPayload } from './types';
import { ApiCommands } from './types';

// Deliberately plain thunks, not `createAppAsyncThunk`: each only sends a WS
// command, so none needs `getState` or a `rejectValue`, and a package cannot
// see the app's `RootState`. Use a narrow `ApiKeysStore` view if one ever must.

export const createApiKey = createAsyncThunk(
  'apiKeys/createApiKey',
  (data: CreateApiKeyPayload, thunkApi) =>
    thunkApi.dispatch(
      wsMmSend({
        command: ApiCommands.CreateAPIKey,
        ...data,
      }),
    ),
);

export const updateLabelApiKey = createAsyncThunk(
  'apiKeys/updateLabel',
  (data: UpdateApiKeyPayload, thunkApi) =>
    thunkApi.dispatch(
      wsMmSend({
        command: ApiCommands.UpdateAPIKey,
        ...data,
      }),
    ),
);

export const createSubAccount = createAsyncThunk(
  'apiKeys/createSubAccount',
  (data: CreateSubAccountPayload, thunkApi) =>
    thunkApi.dispatch(
      wsMmSend({
        command: ApiCommands.CreateSubAccount,
        ...data,
      }),
    ),
);
